module.exports = __webpack_public_path__ + "static/img/tm04.abdbbfce.png";